<template>
    <div>
      <h1>打字机效果</h1>
      <div class="output">
        <!-- <p>{{ displayedText }}</p> -->
        <div v-html="displayedText"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        fullText: "", // 完整的响应内容
        displayedText: "", // 当前显示的内容
        typingSpeed: 50, // 打字速度（毫秒）
        isTyping: false, // 是否正在打字
      };
    },
    methods: {
      // 处理流式响应
      async fetchStreamingResponse() {
        const url = "https://api.deepseek.com/chat/completions";
        const headers = {
          "Content-Type": "application/json",
          "Authorization": "Bearer sk-7135e423d8874edb8025065d8a6d3055",
        };
        const data = {
          messages: [
            { role: "system", content: "You are a helpful assistant." },
            { role: "user", content: "序号	姓名	账号	篇数	最低正确率	最高正确率	平均正确率	得分	阅读在线总篇数	阅读在线匹配题篇数/等级/正确率	阅读在线判断题篇数/等级/正确率	阅读在线选择题篇数/等级/正确率		初级英语选择题篇数/正确率	AB级英语选择题篇数/正确率1	蔡冰冰	lsnu233071408001	29	40%	100%	80%	80	9	3/4级/60%	3/5级/50%	3/5级/60%		10/100%	10/90%2	曾文荟	lsnu233071408002	29	50%	100%	95%	95	9	3/4级/65%	3/5级/50%	3/5级/70%		10/100%	10/95%，分析数据给出对每个人的建议，评估以及提出不足" },
          ],
          model: "deepseek-chat",
          stream: true,
          temperature:1.0,
        };
  
        try {
          const response = await fetch(url, {
            method: "POST",
            headers,
            body: JSON.stringify(data),
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          const reader = response.body.getReader();
          const decoder = new TextDecoder("utf-8");
  
          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
  
            // 解码流式数据
            const chunk = decoder.decode(value);
            const lines = chunk.split("\n");
  
            // 处理每行数据
            lines.forEach((line) => {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith("data:")) {
                const jsonStr = trimmedLine.slice(5).trim();
                if (jsonStr) {
                  const data = JSON.parse(jsonStr);
                  if (data.choices && data.choices[0].delta.content) {
                    // 将新内容添加到 fullText
                    this.fullText += data.choices[0].delta.content.replace("**", "");
                    // 开始打字机效果
                    if (!this.isTyping) {
                      this.startTypingEffect();
                    }
                  }
                }
              }
            });
          }
        } catch (error) {
          console.error("Fetch error:", error);
        }
      },
  
      // 开始打字机效果
      startTypingEffect() {
        this.isTyping = true;
        let index = 0;
  
        const type = () => {
          if (index < this.fullText.length) {
            this.displayedText += this.fullText.charAt(index);
            index++;
            setTimeout(type, this.typingSpeed);
          } else {
            this.isTyping = false;
          }
        };
  
        type();
      },
    },
    mounted() {
      // 组件加载时开始请求
      this.fetchStreamingResponse();
    },
  };
  </script>
  
  <style>
  .output {
    font-family: monospace;
    font-size: 1.2em;
    white-space: pre-wrap;
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 20px;
  }
  </style>